import { render, staticRenderFns } from "./userBanedModal.vue?vue&type=template&id=f82333e4&"
import script from "./userBanedModal.vue?vue&type=script&lang=js&"
export * from "./userBanedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports